<template>
<div v-if="user.id" class="text-center">
    <p style="font-size:1.3em">
        {{ $t('logging_instead_of_the_user', {attribute: full_name}) }}
        <span class="kt-spinner kt-spinner--success ml-3"></span>
    </p>
</div>
<div v-else class="w-100 py-4">
    <div class="kt-spinner kt-spinner--lg kt-spinner--warning" style="right:50%;"></div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters('user', [
            'user'
        ]),
        full_name() {
            return '"' + this.user.first_name + ' ' + this.user.last_name + '"'
        }
    },
}
</script>

<style>

</style>